var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"index_banner",class:_vm.showBanner ? 'on' : ''},[_c('img',{attrs:{"src":_vm.banner}}),_c('div',{staticClass:"close_btn",on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$tt('关闭'))),_c('span',{staticClass:"iconfont icon-guanbi"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }